__turbopack_context__.v({
  "container": "UnclaimedPrize-module__uL2Xya__container",
  "imageBackground": "UnclaimedPrize-module__uL2Xya__imageBackground",
  "imageBackgroundOverlay": "UnclaimedPrize-module__uL2Xya__imageBackgroundOverlay",
  "modalTierIcon": "UnclaimedPrize-module__uL2Xya__modalTierIcon",
  "overlay": "UnclaimedPrize-module__uL2Xya__overlay",
  "prizeImage": "UnclaimedPrize-module__uL2Xya__prizeImage",
  "textSection": "UnclaimedPrize-module__uL2Xya__textSection",
  "textWhite": "UnclaimedPrize-module__uL2Xya__textWhite",
  "tierIcon": "UnclaimedPrize-module__uL2Xya__tierIcon",
  "title": "UnclaimedPrize-module__uL2Xya__title",
});
